import { green, orange, red } from '@ant-design/colors';
import { getCurrentUtcDate } from '../../helpers/current-utc-date-generator';

import React, { useState, useRef, useEffect } from 'react';
import { Table, Card, Row, Col, Input, Button, Typography, message, Modal, Tooltip } from 'antd';
import { Select as AntdSelect } from 'antd';
import RealUserSelect from '../../components/menu/Form/select/UserSelect';
// ...existing code...
import Checkbox from 'antd/es/checkbox';
import Divider from 'antd/es/divider';
import { Progress, Empty, Select } from 'antd';
import { SaveOutlined, UndoOutlined, DeleteOutlined } from '@ant-design/icons';
import NewUserModal from '../../components/NewUserModal';
import CopyIcon from '../../assets/icons/copy-icon.svg';
import SuccessIcon from '../../assets/icons/success-icon.svg';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/appState';
import { User } from '@models/user';
import { Billing } from '@models/billing';
// ...existing code...
import { makeRequest } from '@helpers/axios-manipulator';
import { USER_TYPES } from '../../../constants';

const { Title } = Typography;
const { Text } = Typography;

// ...existing code...

const Users = () => {
    const user = useSelector((state: RootState) => state.user.user);
    const navigate = useNavigate();
    const isRootUser = (user: User | null) => {
      if (!user) return false;
      // contract_id is now provided by backend for root logic
      const isRoot = user.contract_id === 0 || user.contract_id === '0' || user.profile_name === 'Root';
      // Debug log removed
      return isRoot;
    }
        const inputRef = useRef<HTMLInputElement>(null);
      const [newSelectedUser, setNewSelectedUser] = useState<User | null>(null);
      const [userList, setUserList] = useState<User[]>([]);

      useEffect(() => {
        if (!isRootUser(user)) {
          navigate('/');
        }
      }, [user, navigate]);
      
      // Fetch all users for dropdown on mount
      useEffect(() => {
        if (isRootUser(user)) {
          makeRequest({
            origin: window.location.origin,
            method: 'get',
            url: '/api-users?type=1,3,4',
            headers: {},
          })
            .then((users) => {
              setUserList(users);
            })
            .catch((err) => {
              setUserList([]);
            });
        }
      }, [user]);
    const [contracts, setContracts] = useState<any[]>([]);
  const [data, setData] = useState<User | null>(null);
  const [originalData, setOriginalData] = useState<User | null>(null);

  // All state declarations at the top
  // ...existing code...
  // ...existing code...
  // ...existing code...
  const [billing, setBilling] = useState<Billing>({} as Billing);
  const [contractsKey, setContractsKey] = useState<number>(1)
  const [openNewUserModal, setOpenNewUserModal] = useState(false);
  const [enableRecoveryModal, setEnableRecoveryModal] = useState(false);
  const [editedUserUsername, setEditedUserUsername] = useState()
  const [clickLink, setClickLink] = useState(false);
  const [recoveryLink, setRecoveryLink] = useState("")
  const [repUsers, setRepUsers] = useState([]);
  const [hasNewContract, setHasNewContract] = useState(false)
  const [loading, setLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (originalData && data) {
      const isModified = JSON.stringify(originalData) !== JSON.stringify(data);
      setIsDirty(isModified);
    } else {
      setIsDirty(false);
    }
  }, [data, originalData]);

  // Fetch reps when user type 1 is selected
  useEffect(() => {
    if (data?.type === 1 && data?.id) {
      makeRequest({
        origin: window.location.origin,
        method: 'get',
        url: '/api-users?type=3,4',
        headers: {},
      })
        .then((users) => setRepUsers(users))
        .catch(() => setRepUsers([]));
    } else {
      setRepUsers([]);
    }
  }, [data?.type, data?.id]);
        const saveContractRow = async (idx: number): Promise<boolean> => {
          const contract = contracts[idx];
          // Validate required fields
          const requiredFields = [
            contract.artist_id || contract.rep_id,
            contract.fee,
            contract.rep_type
          ];
          if (requiredFields.some(field => field === undefined || field === null || field === '')) {
            message.error('Please fill in all contract fields before saving.');
            return false;
          }

          if (contract.fee === 0) {
            message.error('Commission cannot be 0.');
            return false;
          }
          // Prevent saving if rep_id or artist_id is 'undefined' or not a valid UUID
          const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
          if ((contract.rep_id && !uuidRegex.test(contract.rep_id)) || (contract.artist_id && !uuidRegex.test(contract.artist_id))) {
            message.error('Please select a valid rep/dealer/manager before saving.');
            return false;
          }

          if (data.type === 1) { // Main user is an Artist
              const repUser = repUsers.find(u => u.id === contract.rep_id);
              if (repUser && ![3, 4].includes(repUser.type)) {
                  message.error('Invalid contract: An artist can only be represented by a Dealer or a Manager.');
                  return false;
              }
          } else if (data.type === 3 || data.type === 4) { // Main user is a Dealer/Manager
              const artistUser = userList.find(u => u.id === contract.artist_id);
              if (artistUser && artistUser.type !== 1) {
                  message.error('Invalid contract: A Dealer or Manager can only represent an Artist.');
                  return false;
              }
          }

          // Check for duplicate artist_id or rep_id in contracts
          const isArtistUser = data.type === 1;
          const idField = isArtistUser ? 'rep_id' : 'artist_id';
          const idValue = contract[idField];
          const duplicate = contracts.some((c, i) => i !== idx && c[idField] && c[idField] === idValue);
          if (duplicate) {
            message.error('Duplicate contract detected. Each artist/dealer must be unique.');
            return false;
          }
          setLoading(true);
          try {
            // Fill all required fields for backend
            const now = new Date().toISOString();
            const contractPayload = {
              id: contract.id,
              artist_id: contract.artist_id || null,
              dealer_profile: contract.dealer_profile || '',
              dealer_username: contract.dealer_username || '',
              rep_id: contract.rep_id || null,
              rep_type: contract.rep_type || '',
              status: contract.status || 'active',
              fee: contract.fee,
              creation_date: contract.creation_date || now,
              last_updated_Date: now,
              last_updated_by: user.id,
            };

            // API call to save contract(s)
            await makeRequest({
              origin: window.location.origin,
              method: 'post',
              url: '/api-manipulate-contracts',
              headers: { 'Content-Type': 'application/json' },
              data: { contracts: [contractPayload] },
            });
            message.success('Contract saved!');
            setLoading(false);
            if (hasNewContract) {
              setHasNewContract(false);
            } else {
              await getRelatedContracts();
            }
            return true;
          } catch (error) {
            message.error('Failed to save contract.');
            setLoading(false);
            return false;
          }
        };
      // Helper to mark contract as inactive
      const deleteContractRow = async (contract, idx) => {
        if (!contract.id) {
          // Unsaved contract, just remove from local state
          setContracts(contracts.filter((_, i) => i !== idx));
          return;
        }
        setLoading(true);
        try {
          const response = await makeRequest({
            origin: window.location.origin,
            method: 'post',
            url: '/api-update-contract',
            headers: { 'Content-Type': 'application/json' },
            data: { ...contract, status: 'inactive' },
          });
          // Remove from UI (filter out inactive)
          const updated = [...contracts];
          updated[idx] = { ...updated[idx], status: 'inactive' };
          setContracts(updated.filter(c => c.status === 'active'));
          setLoading(false);
          message.success('Contract deleted (set inactive)');
        } catch (error) {
          setLoading(false);
          message.error('Error deleting contract');
        }
      };
  useEffect(() => {
    if (!enableRecoveryModal) {
      if (inputRef.current) inputRef.current.blur();
      // Move focus to body to avoid aria-hidden/focus trap warning
      if (typeof document !== 'undefined' && document.body) {
        document.body.focus();
      }
    }
  }, [enableRecoveryModal]);

  const copyInputContent = () => {
    if (!inputRef.current) return;
    inputRef.current.select();

    try {
      document.execCommand('copy');
      setClickLink(true);
    } catch (err) {
      console.error('Error copying: ', err);
    }
  };

  // ...existing code...

    const fetchFullUser = async (id: string) => {
    try {
      const userDetails = await makeRequest({
      origin: window.location.origin,
      method: 'get',
      url: `/api-user/${id}`,
      headers: {},
      });
      setData(userDetails);
      setOriginalData(userDetails);
      setNewSelectedUser(userDetails);
    } catch (error) {
      message.error('Failed to fetch user details.');
    }
    };

    const handleUserChange = (id: string) => {
    const isAnyEditing = contracts.some(contract => contract.editing === true);
    const selected = userList.find(u => u.id === id);

    if (isAnyEditing) {
      Modal.confirm({
        title: 'You have unsaved changes',
        content: 'Do you want to save your changes before switching users?',
        okText: 'Save and Continue',
        cancelText: 'Discard Changes',
        onOk: async () => {
          const editingContractsWithIndexes = contracts
            .map((c, i) => ({ contract: c, index: i }))
            .filter(({ contract }) => contract.editing);

          let allSaved = true;
          for (const { contract, index } of editingContractsWithIndexes) {
            const saved = await saveContractRow(index);
            if (!saved) {
              allSaved = false;
              break;
            }
          }

          if (allSaved && selected) {
            await fetchFullUser(selected.id);
          }
        },
        onCancel: () => {
          if (selected) fetchFullUser(selected.id);
        },
      });
    } else {
      if (selected) fetchFullUser(selected.id);
    }
  }

  const contractsPercent = contracts.reduce((sum, contract) => sum + contract.fee, 0);

  // ...existing code...
  const isAnyEditing = contracts.some(contract => contract.editing === true);
  // ...existing code...

  // Use message from antd directly
  const revertChanges = () => {
    setData(originalData);
  }

  const handleWipe = async () => {
    if (!data) return;

    let summaryContent = '';
    try {
      const summary: any = await makeRequest({
        origin: window.location.origin,
        method: 'get',
        url: `/api-users/wipe-summary/${data.id}`,
        headers: {},
      });

      if (summary) {
        const items = [];
        if (summary.artworks > 0) items.push(`${summary.artworks} Artworks`);
        if (summary.placards > 0) items.push(`${summary.placards} Placards`);
        if (summary.artworks_history > 0) items.push(`${summary.artworks_history} Artwork History Entries`);
        if (summary.analytics_placards > 0) items.push(`${summary.analytics_placards} Placard Analytics Entries`);
        if (summary.artist_contracts > 0) items.push(`${summary.artist_contracts} Contracts (Artist side)`);
        if (summary.artwork_contracts > 0) items.push(`${summary.artwork_contracts} Contracts (Rep side)`);
        if (summary.business_events > 0) items.push(`${summary.business_events} Hosted Events`);
        if (summary.client_admin_properties > 0) items.push(`${summary.client_admin_properties} Client Admin Properties`);
        if (summary.cv_entries > 0) items.push(`${summary.cv_entries} CV Entries`);
        if (summary.billing_records > 0) items.push(`${summary.billing_records} Billing Records`);
        if (summary.billing_users > 0) items.push(`${summary.billing_users} Billing Users (Google/Email)`);
        if (summary.orders > 0) items.push(`${summary.orders} Orders`);
        if (summary.onboarding_users > 0) items.push(`${summary.onboarding_users} Onboarding Records`);
        if (summary.artwork_formats > 0) items.push(`${summary.artwork_formats} Artwork Formats`);
        if (summary.artwork_genres > 0) items.push(`${summary.artwork_genres} Artwork Genres`);
        if (summary.artwork_materials > 0) items.push(`${summary.artwork_materials} Artwork Materials`);
        if (summary.user_features > 0) items.push(`${summary.user_features} User Features`);
        if (summary.artist_profiles > 0) items.push(`${summary.artist_profiles} Artist Profiles`);
        
        if (items.length > 0) {
          summaryContent = (
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <Text strong>The following data will be permanently deleted:</Text>
              <ul style={{ paddingLeft: 20, marginTop: 5 }}>
                {items.map((item, idx) => <li key={idx}>{item}</li>)}
              </ul>
            </div>
          ) as any;
        } else {
            summaryContent = 'No related data found.';
        }
      }
    } catch (error) {
      console.error('Failed to fetch wipe summary', error);
      summaryContent = 'Could not load data summary. Proceed with caution.';
    }

    Modal.confirm({
      title: 'Wipe User Data',
      width: 600,
      content: (
        <div>
          <p>Are you sure you want to completely wipe user, and all related data? <b>{data.username}</b>?</p>
          {summaryContent}
          <p style={{ color: red[5], marginTop: 10 }}>This action CANNOT be undone.</p>
        </div>
      ),
      okText: 'Yes, Wipe Everything',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await makeRequest({
            origin: window.location.origin,
            method: 'delete',
            url: `/api-users/wipe/${data.id}`,
            headers: {},
          });
          message.success(`User ${data.username} wiped successfully.`);
          setData(null);
          setOriginalData(null);
          // Refresh user list logic
          if (isRootUser(user)) {
             try {
               const updatedList = await makeRequest({
                  origin: window.location.origin,
                  method: 'get',
                  url: '/api-users?type=1,3,4',
                  headers: {},
               });
               setUserList(updatedList || []);
             } catch(e) { setUserList([]) }
          }
        } catch (error) {
           if (error && typeof error === 'object' && 'message' in error) {
             message.error(`Failed to wipe user: ${(error as any).message}`);
           } else {
             message.error('Failed to wipe user.');
           }
        }
      },
    });
  };


  const save = async () => {
    if (data?.username?.length && data?.username?.length > 20)
      return message.error('username must have a maximum of 20 characters')
    setLoading(true)

    try {
      const userToSave = {
        id: data.id,
        username: data.username,
        display_name: data.display_name,
        profile_name: data.profile_name,
        public_profile: [Array.isArray(data.public_profile) ? data.public_profile[0] : !!data.public_profile],
        wallet_address: data.wallet_address,
        google_id: data.google_id,
        email: data.email,
        stripe_id_acct: data.stripe_id_acct,
      };
      await makeRequest({
        origin: window.location.origin,
        method: 'put',
        url: `/api-user/${data?.id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: { user: userToSave },
      });

      if (billing && data?.type === 4) {
        await makeRequest({
          origin: window.location.origin,
          method: 'put',
          headers: {
            'Content-Type': 'application/json',
          },
          url: `/api-update-billing`,
          data: { billing },
        });
      }

      setOriginalData(data);
      message.success('User saved successfully!');
      setLoading(false);
    } catch (error) {
      message.error('An error occurred while saving the user.');
      setLoading(false);
    }
  }

  const addEmptyContract = () => {
    const newContract = {
      id: "",
      artist_id: data.type === 1 ? data.id : "",
      dealer_profile: data.type !== 1 ? data.profile_name : "",
      dealer_username: data.type !== 1 ? data.username : "",
      rep_id: data.type !== 1 ? data.id : "",
      rep_type: 4,
      status: "active",
      fee: 0,
      creation_date: getCurrentUtcDate(),
      last_updated_Date: getCurrentUtcDate(),
      last_updated_by: user.id,
      editing: true
    };
    setContracts(prevContracts => [...prevContracts, newContract]);
    setHasNewContract(true)
  };

  const getRelatedContracts = async () => {
    // Only fetch contracts for types 1, 3, or 4
    if (![1, 3, 4, "1", "3", "4"].includes(data?.type)) {
      setContracts([]);
      return;
    }
    try {
      const response = await makeRequest({
        origin: window.location.origin,
        method: 'get',
        url: `/api-available-contracts/${data?.id}/${data?.type}`,
        headers: {},
      });
      setContracts(response.map((c: any) => ({ ...c, editing: false })))
    } catch (error) {
      setContracts([]);
    }
  }

  const getBilling = async () => {
    try {
      const response = await makeRequest({
        origin: window.location.origin,
        method: 'get',
        url: `/api-billing/${data?.id}`,
        headers: {},
      });
      setBilling(response)
    } catch (error) {
      console.error('Error fetching billing:', error);
    }
  }

  useEffect(() => {
    if (data && Object.keys(data)?.length > 0 && !hasNewContract) {
      getRelatedContracts();
      if (data?.type === 4) getBilling();
    }
  }, [data, hasNewContract]);

  useEffect(() => { setContractsKey(contractsKey + 1) }, [contracts])

  const getArtistContractTooltip = (record: any, idx: number) => {
      if (!record.rep_id) return 'Please select a dealer/manager.';
      if (contracts.some((c, i) => i !== idx && c.rep_id && c.rep_id === record.rep_id)) return 'This dealer/manager is already in a contract.';
      if (!record.fee) return 'Commission cannot be 0.';
      if (!record.rep_type) return 'Please select a contract type.';
      return '';
  };

  const getDealerContractTooltip = (record: any, idx: number) => {
      if (!record.artist_id) return 'Please select an artist.';
      if (contracts.some((c, i) => i !== idx && c.artist_id && c.artist_id === record.artist_id)) return 'This artist is already in a contract.';
      if (!record.fee) return 'Commission cannot be 0.';
      if (!record.rep_type) return 'Please select a contract type.';
      return '';
  };


  return (
    <>
      {/* Show Create User button for root users */}
      {isRootUser(user) && (
        <div style={{ marginBottom: 24 }}>
          <Button type="primary" onClick={() => setOpenNewUserModal(true)}>
            Create User
          </Button>
        </div>
      )}
      <Card
        style={{ marginBottom: 24, borderRadius: 12, boxShadow: '0 2px 8px #f0f1f2', width: '100%' }}
        styles={{ body: { padding: 20 } }}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} md={8} style={{ display: 'flex', alignItems: 'baseline' }}>
            <Text style={{ marginRight: 8, minWidth: 70, textAlign: 'right', whiteSpace: 'nowrap' }}>Select User</Text>
            <AntdSelect
              showSearch
              style={{ width: '100%' }}
              placeholder="Select user"
              optionFilterProp="children"
              value={data?.id || undefined}
              onChange={handleUserChange}
              filterOption={(input, option) => {
                const user = userList.find(u => u.id === option?.value);
                if (!user) return false;
                const searchText = `${user.username} ${USER_TYPES[user.type]}`.toLowerCase();
                return searchText.includes(input.toLowerCase());
              }}
            >
              {userList.map(user => (
                <AntdSelect.Option key={user.id} value={user.id}>
                  {user.username} ({USER_TYPES[user.type]})
                </AntdSelect.Option>
              ))}
            </AntdSelect>
          </Col>
          <Col xs={24} md={8} style={{ display: 'flex', alignItems: 'baseline' }}>
            <Text style={{ marginRight: 8, minWidth: 70, textAlign: 'right', whiteSpace: 'nowrap'}}>
              User Type
            </Text>
            <Input
              disabled
              value={USER_TYPES[data?.type]}
              placeholder="User type"
              style={{ width: 150 }}
            />
          </Col>
          <Col xs={24} md={8} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <img
              src={data?.profile_image_url && data.profile_image_url.trim() !== "" ? data.profile_image_url : "/favicon.ico"}
              alt="Profile"
              style={{ width: 128, height: 128, borderRadius: '50%', objectFit: 'cover', marginBottom: 8 }}
              onError={(e) => { e.currentTarget.src = "/favicon.ico"; }}
            />
          </Col>
        </Row>
      </Card>

      <Card
        style={{ marginBottom: 24, borderRadius: 12, boxShadow: '0 2px 8px #f0f1f2', width: '100%' }}
        styles={{ body: { padding: 20 } }}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} md={6}>
            <Text style={{ marginRight: 8, minWidth: 70, textAlign: 'right' }}>
              Username
            </Text>
            <Input
              disabled={!data}
              className='mb-5'
              value={data?.username || ''}
              count={{ show: true, max: 20 }}
              onChange={(e) => setData({ ...data, username: e.target.value })}
              placeholder="Username"
              style={{ width: '100%' }}
            />
          </Col>
          <Col xs={24} md={6}>
            <Text style={{ marginRight: 8, minWidth: 90, textAlign: 'right' }}>
              Display name
            </Text>
            <Input
              disabled={!data}
              className='mb-5'
              value={data?.display_name || ''}
              onChange={(e) => setData({ ...data, display_name: e.target.value })}
              placeholder="Display name"
              style={{ width: '100%' }}
            />
          </Col>
          <Col xs={24} md={6}>
            <Text style={{ marginRight: 8, minWidth: 90, textAlign: 'right' }}>
              Profile name
            </Text>
            <Input
              disabled={!data}
              className='mb-5'
              value={data?.profile_name || ''}
              onChange={(e) => setData({ ...data, profile_name: e.target.value })}
              placeholder="Profile name"
              style={{ width: '100%' }}
            />
          </Col>
          <Col xs={24} md={6} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', height: '100%' }}>
            <Text style={{ minWidth: 90, textAlign: 'center', marginBottom: 4 }}>
              Public Profile
            </Text>
            <div style={{ display: 'flex', alignItems: 'center', height: '32px' }}>
              <Checkbox
                checked={Array.isArray(data?.public_profile) ? data?.public_profile[0] : !!data?.public_profile}
                disabled={!data}
                onChange={e => setData({ ...data, public_profile: e.target.checked })}
              >
                {(Array.isArray(data?.public_profile) ? data?.public_profile[0] : !!data?.public_profile) ? 'Yes' : 'No'}
              </Checkbox>
            </div>
          </Col>
        </Row>
      </Card>

      <Card
        style={{ marginBottom: 24, borderRadius: 12, boxShadow: '0 2px 8px #f0f1f2' }}
        styles={{ body: { padding: 20 } }}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} md={8}>
            <Text style={{ marginRight: 8, minWidth: 70, textAlign: 'right', whiteSpace: 'nowrap' }}>
              Account ID
            </Text>
            <Input
              disabled={!data}
              className='mb-5'
              value={data?.id || ''}
              style={{ width: '100%', fontFamily: 'monospace' }}
              readOnly
              placeholder="Account id"
            />
          </Col>
          <Col xs={24} md={8}>
            <Text style={{ marginRight: 8, minWidth: 70, textAlign: 'right' }}>
              Wallet address
            </Text>
            <Input
              disabled={!data}
              className='mb-5'
              value={data?.wallet_address || ''}
              onChange={(e) => setData({ ...data, wallet_address: e.target.value })}
              placeholder="wallet address"
              style={{ width: '100%' }}
            />
          </Col>
          <Col xs={24} md={8}>
            <Text style={{ marginRight: 8, minWidth: 70, textAlign: 'right' }}>
              Google ID
            </Text>
            <Input
              disabled={!data}
              className='mb-5'
              value={data?.google_id || ''}
              onChange={(e) => setData({ ...data, google_id: e.target.value })}
              placeholder="google id"
              style={{ width: '100%' }}
            />
          </Col>
        </Row>
      </Card>

      <Card
        style={{ marginBottom: 24, borderRadius: 12, boxShadow: '0 2px 8px #f0f1f2', width: '100%' }}
        styles={{ body: { padding: 20 } }}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} md={12}>
            <Text style={{ marginRight: 8, minWidth: 70, textAlign: 'right' }}>
              Email
            </Text>
            <Input
              disabled={!data}
              className='mb-5'
              value={data?.email || ''}
              onChange={(e) => setData({ ...data, email: e.target.value })}
              placeholder="Email"
              style={{ width: '100%' }}
            />
          </Col>
          <Col xs={24} md={12}>
            <Text style={{ marginRight: 8, minWidth: 70, textAlign: 'right' }}>
              Stripe ID
            </Text>
            <Input
              disabled={!data}
              className='mb-5'
              value={data?.stripe_id_acct || ''}
              onChange={(e) => setData({ ...data, stripe_id_acct: e.target.value })}
              placeholder="Stripe ID"
              style={{ width: '100%' }}
            />
          </Col>
        </Row>
      </Card>

      <div style={{ marginBottom: 24 }}>
        <Button
          disabled={!isDirty || loading}
          type="primary"
          icon={<SaveOutlined />}
          loading={loading}
          onClick={() => save()}
          style={{ marginRight: 8 }}
        >
          Save
        </Button>
        <Button
          disabled={!isDirty || loading}
          icon={<UndoOutlined />}
          onClick={revertChanges}
          style={{ marginRight: 8 }}
        >
          Revert Changes
        </Button>
        {isRootUser(user) && data && (
          <Button
            type="primary"
            danger
            icon={<DeleteOutlined />}
            loading={loading}
            onClick={handleWipe}
          >
            Wipe User
          </Button>
        )}
      </div>

      {data && data?.type === 4 &&
        <>
          <Text>business premium</Text>
          <Input
            disabled={billing?.premium === undefined || billing?.premium === null}
            className="mb-5"
            value={billing?.premium ?? ''}
            onChange={(e) => setBilling({ ...billing, premium: e.target.value === '' ? undefined : parseInt(e.target.value) || 0 })}
          />

          <Divider className="my-0" titlePlacement="left" styles={{ content: { margin: 0 } }}>
            <Text strong>escrow account</Text> - <Text type={billing?.is_escrow_enabled ? "success" : "danger"}>{billing?.is_escrow_enabled ? "Active" : "Inactive"}</Text>
          </Divider>
          <Row gutter={8}>
            <Col span={24} md={12}>
              <Text>escrow id</Text>
              <Input disabled className='mb-5' value={billing?.escrow_id || ''} />
            </Col>
            <Col span={24} md={12}>
              <Text>escrow premium</Text>
              <Input disabled className='mb-5' value={billing?.escrow_premium || ''} />
            </Col>
          </Row>
        </>
      }

      {data && data?.type === 1 && (
        <>
          <Title className='mt-0' level={4}>Contracts</Title>
          <Progress percent={contractsPercent} steps={10}
            status="active"
            strokeColor={[green[2], green[3], green[4], orange[3], orange[4], orange[5], red[4], red[5], red[6], red[7]]}
          />
          <p className='mt-0'>
            <Text className='mt-0' type="secondary">artist's committed percentage</Text>
          </p>
          {Object.keys(contracts).length === 0 ? (
            <Empty
              styles={{ image: { height: 60 } }}
              description={<Typography.Text>no contract found</Typography.Text>}
            >
              <Button onClick={addEmptyContract}>Create Now</Button>
            </Empty>
          ) : (
            <>
              {!hasNewContract && contracts.length <= 4 && (
                <Button className='mt-4' type="primary" onClick={addEmptyContract}>Create contract</Button>
              )}
              <Table
                dataSource={contracts.map((contract, i) => ({ ...contract, key: contract.id || i }))}
                pagination={false}
                style={{ marginTop: 16 }}
              >
                <Table.Column
                  title="Rep ID"
                  dataIndex="rep_id"
                  key="rep_id"
                  align="center"
                  render={(_, record) => <Text>{record.rep_id}</Text>}
                />
                <Table.Column
                  title="Rep (Dealer/Manager)"
                  key="rep_select"
                  align="center"
                  render={(_, record, idx) => (
                    <>
                      {record.editing ? (
                        <RealUserSelect
                          key={`rep-select-${idx}-${contractsKey}`}
                          update={true}
                          className='mb-0'
                          setData={user => {
                            if (!user) return;
                            const updated = [...contracts];
                            updated[idx] = {
                              ...updated[idx],
                              rep_id: user.id,
                              dealer_profile: user.profile || user.dealer_profile || '',
                              dealer_username: user.username || ''
                            };
                            setContracts(updated);
                          }}
                          data={{}}
                          selectedUser={typeof record.dealer_username === 'object' ? record.dealer_username.username : record.dealer_username || ''}
                          width="100%"
                          allowedTypes={data?.type === 1 ? [3, 4] : [1]}
                          usedDealerIds={contracts.filter((c, i) => i !== idx && c.rep_id).map(c => c.rep_id)}
                        />
                      ) : (
                        <Text type="secondary">{record.dealer_username || 'No rep selected'}</Text>
                      )}
                    </>
                  )}
                />
                <Table.Column
                  title="Dealer Profile"
                  dataIndex="dealer_profile"
                  key="dealer_profile"
                  align="center"
                  render={(_, record) => <Text>{record.dealer_profile}</Text>}
                />
                <Table.Column
                  title="Dealer Username"
                  dataIndex="dealer_username"
                  key="dealer_username"
                  align="center"
                  render={(_, record) => <Text>{record.dealer_username}</Text>}
                />
                <Table.Column
                  title="Commission Value%"
                  dataIndex="fee"
                  key="fee"
                  align="center"
                  render={(_, record, idx) => (
                    <Input
                      type="number"
                      min={0}
                      max={100}
                      value={record.fee}
                      disabled={!record.editing}
                      onChange={e => {
                        const updated = [...contracts];
                        updated[idx] = { ...updated[idx], fee: Number(e.target.value) };
                        setContracts(updated);
                      }}
                      style={{ width: 80, textAlign: 'center' }}
                    />
                  )}
                />
                <Table.Column
                  title="Contract Type"
                  dataIndex="rep_type"
                  key="rep_type"
                  align="center"
                  render={(_, record, idx) => (
                    <Select
                      value={String(record.rep_type)}
                      disabled={!record.editing}
                      onChange={val => {
                        const updated = [...contracts];
                        updated[idx] = { ...updated[idx], rep_type: Number(val) };
                        setContracts(updated);
                      }}
                      style={{ minWidth: '280px', width: '100%', textAlign: 'center' }}
                      options={[{ label: "4 - artwork representation", value: "4" }, { label: "3 - artist management", value: "3" }]}
                    />
                  )}
                />
                <Table.Column
                  key="actions"
                  align="center"
                  render={(_, record, idx) => (
                    <>
                      {record.editing ? (
                        <>
                          {record.id && ( // If it's an existing contract being edited, show "Cancel Edit"
                            <Button type="default" size="small" style={{ marginRight: 8 }} onClick={() => {
                              const updated = [...contracts];
                              updated[idx] = { ...updated[idx], editing: false };
                              setContracts(updated);
                            }}>Cancel</Button>
                          )}
                          <Button type="primary" danger size="small" style={{ marginRight: 8 }} onClick={() => {
                            deleteContractRow(record, idx);
                          }}>Delete</Button>
                          <Tooltip title={getArtistContractTooltip(record, idx)}>
                            <span>
                              <Button
                                type="primary"
                                size="small"
                                loading={loading}
                                disabled={
                                  !record.fee ||
                                  !record.rep_type ||
                                  !record.rep_id ||
                                  contracts.some((c, i) => i !== idx && c.rep_id && c.rep_id === record.rep_id)
                                }
                                onClick={() => {
                                  saveContractRow(idx);
                                }}
                              >Save</Button>
                            </span>
                          </Tooltip>
                        </>
                      ) : (
                        <>
                          {record.id && ( // If it's an existing contract and not editing, show "Edit"
                            <Button type="primary" size="small" style={{ marginRight: 8 }} onClick={() => {
                              const updated = [...contracts];
                              updated[idx] = { ...updated[idx], editing: true };
                              setContracts(updated);
                            }}>Edit</Button>
                          )}
                          <Button type="primary" danger size="small" style={{ marginRight: 8 }} onClick={() => {
                            deleteContractRow(record, idx);
                          }}>Delete</Button>
                        </>
                      )}
                    </>
                  )}
                />
              </Table>
            </>
          )}
        </>
      )}

      {data && (data?.type === 3 || data?.type === 4) &&
        <>
          <Title className='mt-0' level={4}>Contracts</Title>
          {Object.keys(contracts).length === 0 ? (
            <Empty
              styles={{ image: { height: 60 } }}
              description={<Typography.Text>no contract found</Typography.Text>}
            >
              <Button onClick={addEmptyContract}>Create Now</Button>
            </Empty>
          ) : (
            <>
              {!hasNewContract && (
                <Button className='mt-4' type="primary" onClick={addEmptyContract}>Create contract</Button>
              )}
              <Table
                dataSource={contracts.map((contract, i) => ({ ...contract, key: contract.id || i }))}
                pagination={false}
                style={{ marginTop: 16 }}
              >
                <Table.Column
                  title="Artist ID" // This will display the artist_id
                  dataIndex="artist_id"
                  key="artist_id"
                  align="center"
                  render={(_, record) => <Text>{record.artist_id}</Text>}
                />
                <Table.Column
                  title="Artists" // This will be the UserSelect for the Artist
                  key="artist_select"
                  align="center"
                  render={(_, record, idx) => (
                    <>
                      {record.editing ? (
                        <RealUserSelect
                          key={`artist-select-${idx}-${contractsKey}`}
                          update={true}
                          className='mb-0'
                          setData={user => {
                            if (!user) return;
                            const updated = [...contracts];
                            updated[idx] = { ...updated[idx], artist_id: user.id, artist_username: user.username, artist_profile: user.profile }; // Assuming user.profile is available
                            setContracts(updated);
                          }}
                          data={{}}
                          selectedUser={typeof record.artist_username === 'object' ? record.artist_username.username : record.artist_username || ''}
                          width="100%"
                          allowedTypes={[1]}
                          usedDealerIds={contracts.filter((c, i) => i !== idx && c.artist_id).map(c => c.artist_id)}
                        />
                      ) : (
                        <Text type="secondary">{record.artist_username || 'No artist selected'}</Text>
                      )}
                    </>
                  )}
                />
                <Table.Column
                  title="Dealer Profile" // This will display the artist's profile
                  dataIndex="artist_profile"
                  key="artist_profile"
                  align="center"
                  render={(_, record) => <Text>{record.artist_profile || record.dealer_profile || ''}</Text>}
                />
                <Table.Column
                  title="Dealer Username" // This will display the artist's username
                  dataIndex="artist_username"
                  key="artist_username"
                  align="center"
                  render={(_, record) => <Text>{record.artist_username || record.dealer_username || ''}</Text>}
                />
                <Table.Column
                  title="Commission %"
                  dataIndex="fee"
                  key="fee"
                  align="center"
                  render={(_, record, idx) => (
                    <Input
                      type="number"
                      min={0}
                      max={100}
                      value={record.fee}
                      disabled={!record.editing}
                      onChange={e => {
                        const updated = [...contracts];
                        updated[idx] = { ...updated[idx], fee: Number(e.target.value) };
                        setContracts(updated);
                      }}
                      style={{ width: 80, textAlign: 'center' }}
                    />
                  )}
                />
                <Table.Column
                  title="Contract Type"
                  dataIndex="rep_type"
                  key="rep_type"
                  align="center"
                  render={(_, record, idx) => (
                    <Select
                      value={String(record.rep_type)}
                      disabled={!record.editing}
                      onChange={val => {
                        const updated = [...contracts];
                        updated[idx] = { ...updated[idx], rep_type: Number(val) };
                        setContracts(updated);
                      }}
                      style={{ minWidth: '280px', width: '100%', textAlign: 'center' }}
                      options={[{ label: "4 - artwork representation", value: "4" }, { label: "3 - artist management", value: "3" }]}
                    />
                  )}
                />
                <Table.Column
                  title="Actions"
                  key="actions"
                  align="center"
                  render={(_, record, idx) => (
                    <>
                      {record.editing ? (
                        <>
                          {record.id && ( // If it's an existing contract being edited, show "Cancel Edit"
                            <Button type="default" size="small" style={{ marginRight: 8 }} onClick={() => {
                              const updated = [...contracts];
                              updated[idx] = { ...updated[idx], editing: false };
                              setContracts(updated);
                            }}>Cancel</Button>
                          )}
                          <Button type="primary" danger size="small" style={{ marginRight: 8 }} onClick={() => {
                            deleteContractRow(record, idx);
                          }}>Delete</Button>
                          <Tooltip title={getDealerContractTooltip(record, idx)}>
                            <span>
                              <Button type="primary" size="small" loading={loading}
                                disabled={
                                  !record.fee ||
                                  !record.rep_type ||
                                  !record.artist_id ||
                                  contracts.some((c, i) => i !== idx && c.artist_id && c.artist_id === record.artist_id)
                                }
                                onClick={() => {
                                  saveContractRow(idx);
                                }}>Save</Button>
                            </span>
                          </Tooltip>
                        </>
                      ) : (
                        <>
                          {record.id && ( // If it's an existing contract and not editing, show "Edit"
                            <Button type="primary" size="small" style={{ marginRight: 8 }} onClick={() => {
                              const updated = [...contracts];
                              updated[idx] = { ...updated[idx], editing: true };
                              setContracts(updated);
                            }}>Edit</Button>
                          )}
                          <Button type="primary" danger size="small" style={{ marginRight: 8 }} onClick={() => {
                            deleteContractRow(record, idx);
                          }}>Delete</Button>
                        </>
                      )}
                    </>
                  )}
                />
              </Table>
            </>
          )}
        </>
      }

      {/* New user modal */}
      <NewUserModal setUserSelected={setNewSelectedUser} open={openNewUserModal} setOpen={setOpenNewUserModal} setParentLoading={setLoading} />
      <Modal
        title="Account Recovery"
        open={enableRecoveryModal}
        onCancel={() => setEnableRecoveryModal(false)}
        destroyOnHidden={true}
        afterClose={() => {
          // Move focus to body after modal closes to avoid aria-hidden/focus warning
          if (typeof document !== 'undefined' && document.body) {
            document.body.focus();
          }
        }}
        footer={
          <Button type="primary" onClick={() => setEnableRecoveryModal(false)}>
            Ok
          </Button>
        }
      >
        <p>You have generated an account recovery link. If the user does not have one yet, copy the link below and send it.</p>
        <p>Or you can clear the user's wallet_address and google_id fields to use the "Re-invite" functionality from the onboarding menu to send an account claim email.</p>
        <div className="relative flex w-full mb-4" style={{ background: '#CCCCCC' }}>
          <input
            ref={inputRef}
            className="flex items-center w-full h-8 border py-2 px-1 border-solid border-gray-border text-gray-text text-xs p-2"
            defaultValue={recoveryLink}
            readOnly
          />
          <img onClick={copyInputContent} style={{ padding: '.5rem' }} width={15} className="object-contain mx-1 my-auto cursor-pointer"
            src={clickLink ? SuccessIcon : CopyIcon} alt="status icon" />
        </div>
      </Modal>
    </>
  )
}

export default Users